import { useEffect } from 'react';
import { UseFormSetValue } from 'react-hook-form';
import { EditableQuestion } from '../../../../../../types';

/**
 * Absence of `input` is what keeps clients that predate it on a plain text box, so
 * switching structured input off has to clear the field rather than leave a half-built
 * widget behind. Mirrors useFollowUpFieldsResetter.
 */
export const useInputFieldResetter = (
  hasStructuredInput: boolean,
  setValue: UseFormSetValue<EditableQuestion>
) => {
  useEffect(() => {
    if (!hasStructuredInput) {
      setValue('input', null);
    }
  }, [hasStructuredInput, setValue]);
};
